<template>
    <div class="mx-auto px-3">
        <span class="text-lg">
            Stock habilidatado
            <strong class="text-theme-primary">
                {{ stockActive }}
            </strong>
        </span>
        <table v-if="inventories.length" class="mt-4 table" :class="tableDark">
            <thead>
                <tr>
                    <th scope="col">
                        <strong> Tienda</strong>
                    </th>
                    <th scope="col">
                        <strong> Precio en tienda</strong>
                    </th>
                    <template v-if="canViewInventory">
                        <th scope="col">
                            <strong> Stock </strong>
                        </th>
                        <th scope="col">
                            <strong> Min stock </strong>
                        </th>
                        <th scope="col">
                            <strong> Max stock </strong>
                        </th>
                    </template>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(item, index) in inventories" :key="index">
                    <td class="w-1/4">
                        <span class="link-warning capitalize">
                            <a
                                :href="`/app/${item.merchant.merchantType}s/detail/${item.merchant.merchantId}`"
                                target="_blank"
                                rel="noopener"
                            >
                                {{ item.isEnabled ? "🟢" : "⚪" }}
                                {{
                                    item.merchant.merchantType
                                        | merchantInfo("type")
                                }}
                                {{ item.merchant.name }}
                            </a>
                        </span>
                    </td>
                    <td class="w-1/4">
                        <div class="flex flex-col items-center">
                            <span class="text-center font-italic font-bold">
                                {{ item.priceOfferMerchant | money }}
                            </span>
                            <span class="text-center font-italic line-through">
                                &nbsp; {{ item.priceMerchant | money }}
                            </span>
                        </div>
                    </td>
                    <template v-if="canViewInventory">
                        <td class="w-2/12">
                            <div></div>
                            <a
                                :href="`/app/inventories/${item.merchant.merchantType}/${item.merchant.merchantId}/detail/${item.referenceId}`"
                                target="_blank"
                                rel="noopener"
                                class="rounded-full bg-theme-card text-black p-2 flex items-center justify-center w-6 h-6"
                            >
                                <span>
                                    {{ item.stock }}
                                </span>
                            </a>
                        </td>
                        <td class="w-2/12">
                            <span>
                                {{ item.minStockMerchant }}
                            </span>
                        </td>
                        <td class="w-2/12">
                            <span>
                                {{ item.maxStockMerchant }}
                            </span>
                        </td>
                    </template>
                </tr>
            </tbody>
        </table>
        <div v-else class="mt-4">
            <strong> No hay inventario en tiendas </strong>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
    name: "InventoryByReferenceTable",
    props: {
        stockActive: {
            default: () => 0,
            type: Number,
            required: false
        },
        inventories: {
            default: () => [],
            type: Array,
            required: true
        }
    },
    data: () => ({}),
    computed: {
        ...mapGetters("control", ["tableDark"]),
        canViewInventory() {
            return this.$ability.hasPermission("inventory:Get");
        }
    },
    mounted() {},
    methods: {}
};
</script>
